export const REFRESH_TOKEN = "refresh_token";
export const ACCESS_TOKEN = "access_token";
export const MINUTE = 60000;
export const RENEW_WINDOW_TIME = 3 * MINUTE; // should refresh 3 minutes before the access token is expired

export const DISALLOW_CHAT_ID = "f96c5186-ba7a-411c-b3a9-90ae4ad452b1";

export const STATUS_CONTENT = {
  waiting_confirm: "Chờ xác nhận",
  delivering: "Đang giao",
  complete: "Đã giao",
  cancel: "Đã hủy",
};
export const STATUS_COLOR = {
  waiting_confirm: "#16884a",
  delivering: "#16884a",
  complete: "#545454",
  cancel: "#9F1E1E",
};

export const SUPPORT_ID = "f40c4ab9-a1b5-4f22-8c2a-d153e2b2ca69";

export const CLOUDFRONT_URI =
  process.env.REACT_APP_CLOUDFRONT_URI ||
  "https://d3hr4eej8cfgwy.cloudfront.net";

  export const CDN_CMC_URI =
  process.env.REACT_APP_CDN_CMC_URI || "https://cdn.sobanhang.com";